import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=95b12540&scoped=true&"
import script from "./FormButton.vue?vue&type=script&lang=js&"
export * from "./FormButton.vue?vue&type=script&lang=js&"
import style0 from "./FormButton.vue?vue&type=style&index=0&id=95b12540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b12540",
  null
  
)

export default component.exports